export const InroomAdminAction = {
  sandboxLogoutMemo: "sandboxLogoutMemo",
  isImportInProgress: "isImportInProgress",
  isUserImportingToDictionary: "isUserImportingToDictionary",
  inquiryInfo: "inquiryInfo",
};

export const InroomAdminMutation = {
  SET_SANDBOX_LOGOUT_MEMO: "SET_SANDBOX_LOGOUT_MEMO",
  SET_IS_IMPORT_IN_PROGRESS: "SET_IS_IMPORT_IN_PROGRESS",
  SET_IS_USER_IMPORTING_TO_DICTIONARY: "SET_IS_USER_IMPORTING_TO_DICTIONARY",
  SET_INQUIRY_INFO: "SET_INQUIRY_INFO",
};
